import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface ISnackState {
  value: IToastrType;
}

interface IToastrType {
  status?: boolean;
  type?: ToastrType;
  message?: string;
  timeout?: number;
  icon?: string;
  options?: {
    duration: number;
  };
}

export enum ToastrType {
  SUCCESS,
  ERROR,
  INFO,
  WARNING,
}

const initialState: ISnackState = {
  value: {
    status: undefined, // open/close
    type: undefined, // 1-success,2-error, 3-info, 4-warning
    message: undefined,
    timeout: undefined,
    icon: undefined,
  },
};
export const slice = createSlice({
  name: 'snackBar',
  initialState: { ...initialState },
  reducers: {
    openSnackAction: (state, action: PayloadAction<IToastrType>) => {
      state.value.status = true;
      state.value.type = action.payload && action.payload.type;
      state.value.message = action.payload && action.payload.message;
      state.value.options = action.payload && action.payload.options;
    },
    closeSnackAction: (state) => {
      state.value.status = false;
    },
  },
});
export const { openSnackAction, closeSnackAction } = slice.actions;
export const selectSnackBarStatus = (state: RootState) => state.snackBar.value?.status;
export const selectSnackBarMessage = (state: RootState) => state.snackBar.value?.message;
export const selectSnackBarType = (state: RootState) => state.snackBar.value?.type;
export const selectSnackBarOptions = (state: RootState) => state.snackBar.value?.options;
export const SnackBarReducer = slice.reducer;
